
import { Base } from '../base-component';

import './form-item-dfc-business.component.scss';

import * as $ from 'jquery';

export class FormItemDfcBusiness extends Base {

	form: HTMLFormElement;
	submitBtn: Element[];
	businessType: HTMLFormElement;
	helpDropDown: HTMLFormElement;

	constructor(element: Element) {
		super(element);
	}

	init() {
		this.form = this.element.querySelector('form') as HTMLFormElement;
		this.submitBtn = Array.from(this.element.querySelectorAll('.js-apply-now__button-business_dfc'));
		this.businessType = this.element.querySelector('.js-business-type') as HTMLFormElement;
		this.helpDropDown = this.element.querySelector(".js-enquiry-type") as HTMLFormElement;
		if (this.helpDropDown) {
			this.displayEnquiryForm(this.helpDropDown.value);
		}
	}

	bindEvents() {

		this.submitBtn.map((item) => item.addEventListener('click', (event) => {
			const formFields: any = this.form.querySelectorAll('input, select');
			const validation = this.validationService.validate(formFields);
			const valid = Array.from(this.form.querySelectorAll(".form__group--error"));
			if (valid.length == 0) {
				this.formsService.detect(this.form, this.element.querySelector('.form__loader--container'), this.element.querySelector('.form__thankyou--container'));
			}
		}));

		if (this.businessType) {
			this.businessType.addEventListener('change', () => this.validateBusinessType('validate'));
		}

		if (this.helpDropDown) {
			this.helpDropDown.addEventListener('change', () => this.displayEnquiryForm(this.helpDropDown.value));
		}

	}

	validateBusinessType(type: string) {

		this.businessOtherDropdown();

		if ((this.businessType.value === 'Private_Company') || (this.businessType.value === 'Close_Corporation')) {

			const field: any = this.form.querySelector('input.form__input--identification');
			const formGroup: any = $(field).closest('.form__group');
			formGroup.removeClass('form__group--error');
			const label: any = formGroup.find('label').text('Business Registration Number');


			field.setAttribute('name', 'business-reg-number');
			field.classList.remove('form__input--identification');
			field.classList.add('form__input--business-registration');
			field.placeholder = 'Enter your business registration number';

		} else {

			const field: any = this.form.querySelector('input.form__input--business-registration');
			const formGroup: any = $(field).closest('.form__group');
			formGroup.removeClass('form__group--error');
			const label: any = formGroup.find('label').text('ID Number');

			field.setAttribute('name', 'id-number');
			field.classList.remove('form__input--required');
			field.classList.add('form__input--identification');
			field.placeholder = 'Enter your South African ID number';
		}

	}

	businessOtherDropdown() {

		let field: any = this.businessType;
		let formGroup: any = $(field).closest('.form__group');
		let formGroups: any = Array.from(this.element.querySelectorAll('.form__group'));
		let formNote: any = this.element.querySelector('.apply-now__note');
		let formButtons: any = this.element.querySelector('.apply-now__buttons');
		let formOtherContainer: any = this.element.querySelector('.form__business-other--container');

		if (this.businessType.value === 'OtherContent') {

			formGroups.map((item: any) => {
				item.classList.add('form__group--hidden');
			});
			formNote.classList.add('hidden');
			formButtons.classList.add('hidden');
			formOtherContainer.classList.add('active');

		} else {

			formGroups.map((item: any) => {
				item.classList.remove('form__group--hidden');
			});
			formNote.classList.remove('hidden');
			formButtons.classList.remove('hidden');
			formOtherContainer.classList.remove('active');

		}

		$(formGroup).removeClass('form__group--hidden');

	}

	displayEnquiryForm(select) {
		const _tmpType = this.businessType.closest(".form__group") as HTMLFormElement;
		const __tmpId = this.element.querySelector('input[name=id-number]');
		let _tmpId: any = '';
		if (__tmpId) {
			_tmpId = __tmpId.closest(".form__group") as HTMLFormElement;
		}
		const __tmpBusiness = this.element.querySelector('input[name=business-reg-number]');
		if (__tmpBusiness) {
			_tmpId = __tmpBusiness.closest(".form__group") as HTMLFormElement;
		}
		const __tmpCustomer = this.element.querySelector('input[name=existing-customer]');
		let _tmpCustomer: any = '';
		if (__tmpCustomer) {
			_tmpCustomer = __tmpCustomer.closest(".form__group") as HTMLFormElement;

		}
		switch (select) {
			case 'Enquiry':
				_tmpType.style.display = "none";
				if (_tmpId != '') {
					// _tmpId.style.display = "none";
					_tmpId.classList.add("form__group--hidden");
					_tmpId.querySelector('input').classList.remove("form__input--required");
				}
				if (_tmpCustomer) {
					_tmpCustomer.classList.add("form__group--hidden");
					// _tmpCustomer.style.display = "none";
				}
				break;
			case 'NewAccount':
				_tmpType.style.display = "block";
				if (_tmpId != '') {
					_tmpId.classList.remove("form__group--hidden");
					// _tmpId.style.display = "block";
					_tmpId.querySelector('input').classList.add("form__input--required");
				}
				if (_tmpCustomer) {
					_tmpCustomer.classList.remove("form__group--hidden");
					// _tmpCustomer.style.display = "block";
				}
				break;
		}
	}

}



// WEBPACK FOOTER //
// ./components/form-item-dfc-business/form-item-dfc-business.component.ts